/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LOCALE_ID, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbIconModule,
  NbMenuModule,
  NbSidebarModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {DecimalPipe, registerLocaleData} from '@angular/common';
import vi from '@angular/common/locales/vi';
import viEt from '@angular/common/locales/extra/vi';
import {NbMomentDateModule} from '@nebular/moment';
import {NbDateFnsDateModule} from '@nebular/date-fns';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxWebstorageModule } from 'ngx-webstorage';
import {ToasterModule} from 'angular2-toaster';
import {NgSelectModule} from '@ng-select/ng-select';
import {AuthInterceptor} from "./interceptor/auth.interceptor";
import {NgxMaskModule} from 'ngx-mask';
import {TreeviewModule} from './shared/components/tree-picker/ngx-treeview';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
registerLocaleData(vi, 'vi-VI', viEt);


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    ToasterModule.forRoot(),
    NgxMaskModule.forRoot(),
    NbTimepickerModule.forRoot(),
    ReactiveFormsModule,
    NgSelectModule,
    NbIconModule,
    FormsModule,
    NgxDatatableModule,
    NgxWebstorageModule.forRoot({prefix: 'app', separator: ':'}),
    NbMomentDateModule,
    NbDateFnsDateModule.forRoot({
      parseOptions: {useAdditionalWeekYearTokens: true, useAdditionalDayOfYearTokens: true},
      formatOptions: {useAdditionalWeekYearTokens: true, useAdditionalDayOfYearTokens: true},
    }),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    TreeviewModule.forRoot(),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
      defaultLanguage: 'vi',
    }),
  ],
  bootstrap: [AppComponent],
  providers: [{provide: LOCALE_ID, useValue: 'vi-VI'}, DecimalPipe,   {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  }]
})
export class AppModule {
}
